import axios, { AxiosResponse } from 'axios';

import { IApiListParams, IBetApiListResponse } from '@/types';

export const loadBets = (params: IApiListParams): Promise<AxiosResponse<IBetApiListResponse>> => {
    return axios.get('/api/bet/list', { params });
};

export const exportBets = (params: IApiListParams): Promise<AxiosResponse<Blob>> => {
    return axios.get('/api/bet/list', { responseType: 'blob', params });
};
